import { Global, css, useTheme } from '@emotion/react';
import { globalcss, globals } from 'common-ui';

const GlobalStyles = () => {
  const theme = useTheme();

  //NOTE: be VERY careful about setting global styles as this component is injected into
  //an existing page and hence global styles here will potentially affect all page styling
  const globalstyles = globalcss(theme);

  // * Add Css releated to embedded app only.
  // * styles applied here will be injected into
  // * an existing pages and hence embeddedStyles here will potentially have side affect all page styling
  const embeddedStyles = css`
    @font-face {
      font-family: 'Escrow';
      font-weight: 900;
      src: url('${globals.assetsPath}/next/fonts/Escrow-Bold.woff2') format('woff2');
    }
    @font-face {
      font-family: 'Escrow';
      font-weight: 600;
      src: url('${globals.assetsPath}/next/fonts/Escrow-Semibold.woff2') format('woff2');
    }
    @font-face {
      font-family: 'EscrowBannerCompressed';
      font-weight: 900;
      src: url('${globals.assetsPath}/next/fonts/EscrowBannerCompressed-Bold.woff2') format('woff2');
    }
    ${globalstyles}
    .vine-react-app {
      font-family: ${theme.fonts.familySecondary};
      font-size: ${theme.fonts.sizeRoot};
    }
    .sticky-header {
      position: fixed;
      top: 0;
      width: 100%;
      z-index: 600;
    }
    .enabled-vine-header {
      .aa-Panel {
        background: ${theme.colors.white};
        clip-path: inset(0 -100vmax);
        z-index: 999;
        box-shadow: 0 0 0 100vmax ${theme.colors.white};
        margin: 0;
        height: 100%;
        padding: 0 13px 67px;
        width: 100% !important;
        ${theme.breakpoints.lg} {
          height: auto;
          padding: 0;
        }
      }
      .aa-PanelLayout {
        max-height: 100%;
        flex-direction: column;
        ${theme.breakpoints.lg} {
          max-height: initial;
        }
      }
      .aa-SourceHeader {
        border-bottom: 0;
      }
    }
  `;
  return <Global styles={embeddedStyles} />;
};
export default GlobalStyles;
